<template>
  <v-app class="grey lighten-3">
    <v-layout>
      <v-flex xs12 sm6 offset-sm3>
        <v-container grid-list-md>
          <v-card>
            <v-card-title class="project">
              <div><span class="headline">Success Payment Page</span></div>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-2 text-none"
                small
                dark
                @click="addBalance"
              >
                Add Balance
              </v-btn>
              <v-btn color="blue darken-2 text-none" small dark @click="back">
                Back
              </v-btn>
            </v-card-title>
            <v-card-text>
              <template>
                <v-data-table
                  :items="indexData.datas"
                  class="elevation-1"
                  hide-actions
                  hide-headers
                >
                  <template v-slot:items="props">
                    <tr>
                      <td>Project ID</td>
                      <td class="text-xs-left">{{ props.item.id }}</td>
                    </tr>
                    <tr>
                      <td>Project Title</td>
                      <td class="text-xs-left">{{ props.item.name }}</td>
                    </tr>
                    <tr>
                      <td>Estimated Starting Time</td>
                      <td class="text-xs-left">{{ props.item.begin_date }}</td>
                    </tr>
                    <tr>
                      <td>Estimated Ending Time</td>
                      <td class="text-xs-left">{{ props.item.end_date }}</td>
                    </tr>
                    <tr>
                      <td>Total Budget</td>
                      <td class="text-xs-left">
                        {{ props.item.total_budget_amount }} Tk
                      </td>
                    </tr>
                    <tr>
                      <td>Available Balance</td>
                      <td class="text-xs-left">
                        {{ props.item.available_balance }} Tk
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </template>
              <div class="mt-3 grey lighten-4">
                <span>
                  If you think your project will go to live now, you have to
                  click the 'live now' button. If you don't think then you can
                  schedule the project by choosing your perfect date and time.
                  For this click the 'schedule' button and save it.
                </span>
              </div>
            </v-card-text>
            <v-card-actions>
              <!-- <button class="button" flat>Scheduled</button> -->
              <v-layout row justify-left>
                <v-dialog v-model="dialog" persistent max-width="390">
                  <template v-slot:activator="{ on }">
                    <v-btn class="button text-none" flat v-on="on">
                      Scheduled
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title class="indigo">
                      <div class="white--text headline">Schedule Room</div>
                    </v-card-title>
                    <v-card-text class="grey lighten-3">
                      <v-form ref="form" v-model="valid" lazy-validation>
                        <v-layout wrap>
                          <v-flex xs12>
                            <v-menu
                              ref="menu"
                              v-model="menu"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="editedItem.date"
                                  :rules="date"
                                  prepend-icon="event"
                                  label="Date"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                ref="picker"
                                v-model="editedItem.date"
                                :min="new Date().toISOString().substr(0, 10)"
                                @change="save"
                              ></v-date-picker>
                            </v-menu>
                          </v-flex>
                        </v-layout>
                        <v-layout wrap>
                          <v-flex xs12>
                            <v-menu
                              ref="menu"
                              v-model="menu2"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              :return-value.sync="time"
                              lazy
                              transition="scale-transition"
                              offset-y
                              full-width
                              max-width="200px"
                              min-width="200px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="editedItem.time"
                                  :rules="timeValidate"
                                  label="Time"
                                  prepend-icon="access_time"
                                  readonly
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-time-picker
                                v-if="menu2"
                                v-model="editedItem.time"
                                full-width
                                @click:minute="$refs.menu.save(time)"
                              ></v-time-picker>
                            </v-menu>
                          </v-flex>
                        </v-layout>
                      </v-form>
                    </v-card-text>
                    <v-card-actions class="indigo">
                      <v-btn color="white darken-1" flat @click="close">
                        Cancel
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn color="white darken-1" flat @click="scheduled">
                        Save
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-layout>
              <v-spacer></v-spacer>
              <v-btn
                class="button text-none"
                flat
                @click="liveNow"
                :disabled="clicked"
              >
                Live Now
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import router from "@/router";

export default {
  data: () => ({
    clicked: false,
    apiUrl: "success-payment",
    dialog: false,
    menu: false,
    time: null,
    menu2: false,
    modal2: false,
    project: {
      id: "",
    },
    editedItem: {
      id: "",
      date: "",
      time: "",
    },
    valid: true,
    date: [(v) => !!v || "Date is required."],
    timeValidate: [(v) => !!v || "Time is required."],
  }),

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "error",
      "statusCode",
      "errorMsg",
    ]),
  },

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "DATE"));
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      let id = localStorage.getItem("projectId");
      this.project.id = id;
      this.editedItem.id = id;
      this.$store.dispatch("responseDataCoins", [this.apiUrl, id]);
    },

    save(date) {
      this.$refs.menu.save(date);
      this.menu = false;
    },

    scheduled() {
      if (
        this.indexData.datas[0].available_balance >=
        this.indexData.datas[0].total_budget_amount
      ) {
        // console.log(this.indexData.datas[0].available_balance);
        if (this.$refs.form.validate()) {
          // console.log(this.editedItem)
          this.$store.dispatch("scheduleProject", [
            "scheduling-project",
            this.editedItem,
          ]);
          this.dialog = false;
        }
      } else {
        alert("Please add balance to your wallet");
      }
    },

    liveNow() {
      if (
        this.indexData.datas[0].available_balance >=
          this.indexData.datas[0].total_budget_amount &&
        parseInt(localStorage.getItem("client_id")) != 1
      ) {
        alert("Please add balance to your wallet");
      } else {
        this.$store.dispatch("projectGoToLive", [this.apiUrl, this.project]);
        this.clicked = true;
      }
    },
    addBalance() {
      router.push("/client-payment-page");
    },
    back() {
      if (this.project.id != null && this.project.id != undefined) {
        this.$store.dispatch("getProjectDetails", [
          this.project.id,
          "client-view",
        ]);
      } else {
        alert("Project id not found!");
      }
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, "");
      }, 300);
    },
  },
};
</script>

<style scoped>
.button {
  font-size: 16px;
  background: #ff2e2e;
  padding: 0.4rem 1.3rem;
  text-align: center;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  margin: 10px;
  color: white;
}
.headline {
  color: white;
}
.project {
  background: #ff2e2e;
}
</style>
